// Mock rows used while the banking-details and beneficiaries pages are not wired to the API.
// Both start from the same signed-in user record (`mockUser`) and add their own fields.

const mockUser = {
            "userId": 2,
            "firstName": "John",
            "lastName": "Doe",
            "emailAddress": "0777757168",
            "phoneNumber": "courageb@xplug.co.zw",
            "isActive": true,
            "locked": false,
            "enabled": true,
            "userType": "EMPLOYEE",
            "userRole": {
                "id": 1,
                "name": "SUPER_ADMIN",
                "description": "User can access all the system functions",
                "creationTimestamp": null,
                "lastUpdateTimestamp": null,
                "permissions": []
            },
};

export const bankingMock = [{
    ...mockUser,
            "BankDetailsId": 789,
            "FranchiseID": 123,
            "MemberID": 456,
            "MemberType": "Joint",
            "ActualPersonId": 303,
            "BankNameId": 5678,
            "Branch_Code": "PQR456",
            "Bank_Note": "Joint account with spouse",
            "Account_Name": "Alice and Bob",
            "Account_Number": "2468135790",
            "Type_of_Account": "Joint Savings",
            "StartDate": "2023-07-24T08:17:55.444Z",
            "Debit_Day": 5,
            "Debit_Day_FirstTimeOnly": 3,
            "DebitUsingFirstTimeOnly": 1,
            "Debit_Note": "Joint account debit",
            "Debit_Active": true,
            "Deleted": 0,
            "DTSTAMP": "2023-07-24T08:17:55.444Z",
            "UserId": 777,
            "IsDefault": 0,
            "maskedCardPAN": "XXXX-XXXX-XXXX-9876",
            "cardExpiryDate": "2024-12-31T00:00:00.000Z",
            "tokenExpiryDate": "2025-01-15T12:00:00.000Z",
            "DebiCheck": 0,
            "canChangePlatform": 1,
            "IsIntenconDebicheck": true,
            "FKDebicheckAuthenticationTypeID": 2345
          },
            {
              "BankDetailsId": 123,
              "FranchiseID": 456,
              "MemberID": 789,
              "MemberType": "Individual",
              "ActualPersonId": 101,
              "BankNameId": 7890,
              "Branch_Code": "ABC123",
              "Bank_Note": "Sample bank note",
              "Account_Name": "John Doe",
              "Account_Number": "1234567890",
              "Type_of_Account": "Savings",
              "StartDate": "2023-07-24T08:17:55.444Z",
              "Debit_Day": 15,
              "Debit_Day_FirstTimeOnly": 10,
              "DebitUsingFirstTimeOnly": 1,
              "Debit_Note": "Sample debit note",
              "Debit_Active": true,
              "Deleted": 0,
              "DTSTAMP": "2023-07-24T08:17:55.444Z",
              "UserId": 999,
              "IsDefault": 1,
              "maskedCardPAN": "XXXX-XXXX-XXXX-1234",
              "cardExpiryDate": "2025-12-31T00:00:00.000Z",
              "tokenExpiryDate": "2026-01-15T12:00:00.000Z",
              "DebiCheck": 0,
              "canChangePlatform": 1,
              "IsIntenconDebicheck": true,
              "FKDebicheckAuthenticationTypeID": 9876
            },
            {
              "BankDetailsId": 456,
              "FranchiseID": 789,
              "MemberID": 101,
              "MemberType": "Company",
              "ActualPersonId": 202,
              "BankNameId": 2345,
              "Branch_Code": "XYZ789",
              "Bank_Note": "Another bank note",
              "Account_Name": "Jane Smith",
              "Account_Number": "9876543210",
              "Type_of_Account": "Checking",
              "StartDate": "2023-07-24T08:17:55.444Z",
              "Debit_Day": 25,
              "Debit_Day_FirstTimeOnly": 20,
              "DebitUsingFirstTimeOnly": 0,
              "Debit_Note": "Another debit note",
              "Debit_Active": false,
              "Deleted": 0,
              "DTSTAMP": "2023-07-24T08:17:55.444Z",
              "UserId": 888,
              "IsDefault": 0,
              "maskedCardPAN": "XXXX-XXXX-XXXX-5678",
              "cardExpiryDate": "2024-06-30T00:00:00.000Z",
              "tokenExpiryDate": "2024-07-01T12:00:00.000Z",
              "DebiCheck": 1,
              "canChangePlatform": 0,
              "IsIntenconDebicheck": false,
              "FKDebicheckAuthenticationTypeID": 3456
            }
];

export const beneficiariesMock = [{
    ...mockUser,
            "BeneficiaryID": 23232,
            "Member_ID": 656565,
            "BenTitle": "Mr",
            "BenName": "Tafadzwa",
            "BenSurname": "Nyemba",
            "BenID": "23-3434334W23",
            "BenDOB": "2023-09-34",
            "BenRelation": "MOTHER",
            "BenTelephone": "0777754443",
            "BenGender": "MALE",
            "PassportNumber": "232223T",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
          },
          {
            "BeneficiaryID": 11111,
            "Member_ID": 989898,
            "BenTitle": "Miss",
            "BenName": "Sophia",
            "BenSurname": "Johnson",
            "BenID": "43-8765432X56",
            "BenDOB": "1990-06-12",
            "BenRelation": "DAUGHTER",
            "BenTelephone": "0888123456",
            "BenGender": "FEMALE",
            "PassportNumber": "ABC123XYZ",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
          },
          {
            "BeneficiaryID": 22222,
            "Member_ID": 757575,
            "BenTitle": "Mrs",
            "BenName": "Emily",
            "BenSurname": "Smith",
            "BenID": "78-5432109Y89",
            "BenDOB": "1975-02-25",
            "BenRelation": "WIFE",
            "BenTelephone": "0777345678",
            "BenGender": "FEMALE",
            "PassportNumber": "XYZ987ABC",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
          }
          ,
          {
            "BeneficiaryID": 33333,
            "Member_ID": 123456,
            "BenTitle": "Mr",
            "BenName": "Michael",
            "BenSurname": "Anderson",
            "BenID": "91-6543210Z45",
            "BenDOB": "1988-11-02",
            "BenRelation": "FATHER",
            "BenTelephone": "0999888777",
            "BenGender": "MALE",
            "PassportNumber": "PQR456LMN",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
          }
          ,{
            "BeneficiaryID": 23232,
            "Member_ID": 656565,
            "BenTitle": "Mr",
            "BenName": "Tafadzwa",
            "BenSurname": "Nyemba",
            "BenID": "23-3434334W23",
            "BenDOB": "2023-09-34",
            "BenRelation": "MOTHER",
            "BenTelephone": "0777754443",
            "BenGender": "MALE",
            "PassportNumber": "232223T",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
          },
        {
          "BeneficiaryID": 23232,
            "Member_ID": 656565,
            "BenTitle": "Mr",
            "BenName": "Tafadzwa",
            "BenSurname": "Nyemba",
            "BenID": "23-3434334W23",
            "BenDOB": "2023-09-34",
            "BenRelation": "MOTHER",
            "BenTelephone": "0777754443",
            "BenGender": "MALE",
            "PassportNumber": "232223T",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
        },
      {
        "BeneficiaryID": 23232,
            "Member_ID": 656565,
            "BenTitle": "Mr",
            "BenName": "Tafadzwa",
            "BenSurname": "Nyemba",
            "BenID": "23-3434334W23",
            "BenDOB": "2023-09-34",
            "BenRelation": "MOTHER",
            "BenTelephone": "0777754443",
            "BenGender": "MALE",
            "PassportNumber": "232223T",
            "DTSTAMP": "2023-07-24T08:17:55.444Z"
}];
